export const HUD_LAYER = Object.freeze({
  TRACE: { id: 'TRACE', defaultPrefs: { enabled: true } },
  LEVELS: { id: 'LEVELS', defaultPrefs: { enabled: true } },
  SPACES: { id: 'SPACES', defaultPrefs: { enabled: true } },
  ASSETS: { id: 'ASSETS', defaultPrefs: { enabled: false } }
});

export class HudLayer {
  #visible;

  facility;
  hud;
  isDirty;
  layerID;
  viewer;

  constructor(layerID, facility, hud, viewer) {
    this.facility = facility;
    this.hud = hud;
    this.viewer = viewer;
    this.dom = createDomLayer(hud.getDocument(), 'dt-hud-layer-' + layerID);

    this.layerID = layerID;
    this.isDirty = false;
    this.#visible = true;
  }

  dispose() {}

  init() {
    return this;
  }

  invalidate() {
    this.isDirty = true;
  }

  isVisible() {
    return this.#visible;
  }

  setVisible(visible) {
    this.#visible = visible;
  }

  update(ts) {}

  clear() {}
  onIsolationChanged(isolation) {}
  onHiddenChanged({ hidden }) {}
  onFacetsUpdated(event) {}
  onFacetsLoaded(event) {}
  onModelChanged(event) {}
  onCameraChanged(camera) {}
  onClusterTransition(clustered) {}

  handleMouseMove(event) {} // ToolController event
}

// Create a minimal, non-sized, div for grouping and layout purposes.
export function createDomLayer(document, id) {
  const div = document.createElement('div');
  div.id = id;
  div.style.width = '0';
  div.style.height = '0';
  return div;
}